import dustinPic from "@/public/images/artists/dustin.png";
import { Artist } from "@/types/types";

export const dustin = {
  id: "20",
  name: "Dustin",
  image: dustinPic,
  description: `Introducing "Dustin," with a voice that blends country's storytelling charm with a rich melodic resonance. From soulful ballads to foot-stomping anthems, Dustin's vocal abilities will not disappoint you.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fdustin-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Folk", "Country", "Indie"],
      secondary: ["Singer", "Storytelling"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
